export default __webpack_public_path__ + "media/images/content-dog-combined-d5374f834858e2017226a2aa4dba5296.png";